import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-popup',
  templateUrl: './map-popup.component.html',
  styleUrls: ['./map-popup.component.css']
})
export class MapPopupComponent implements OnInit {

  @Input() customData: any

  mapData: any = []
  constructor() { }

  ngOnInit(): void {
    console.log(this.customData)
    this.mapData.push(this.customData)
  }
}
